import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { Security } from '@okta/okta-react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './containers/App';
import ScrollToTop from './containers/ScrollToTop';
import PaymentCallback from './components/PaymentCallback';
import store from './store';
import './theme';

const appDom = document.getElementById('app');

console.log(`Starting React App @ ${process.env.VERSION}`); // eslint-disable-line no-console

const DummyDsmPayment = () => <div>Loading...</div>;

// Override Okta's default localStorage with sessionStorage
if (typeof window !== 'undefined') {
  try {
    const originalLocalStorage = window.localStorage;
    const storageProxy = {
      setItem(key, value) {
        if (key.startsWith('okta-')) {
          window.sessionStorage.setItem(key, value);
        } else {
          originalLocalStorage.setItem(key, value);
        }
      },
      getItem(key) {
        if (key.startsWith('okta-')) {
          return window.sessionStorage.getItem(key);
        }
        return originalLocalStorage.getItem(key);
      },
      removeItem(key) {
        if (key.startsWith('okta-')) {
          window.sessionStorage.removeItem(key);
        } else {
          originalLocalStorage.removeItem(key);
        }
      },
      clear() {
        originalLocalStorage.clear();
      },
      key(index) {
        return originalLocalStorage.key(index);
      },
      get length() {
        return originalLocalStorage.length;
      },
    };

    // Use Object.defineProperty for better Firefox compatibility
    Object.defineProperty(window, 'localStorage', {
      configurable: true,
      enumerable: true,
      value: new Proxy(originalLocalStorage, {
        get(target, prop) {
          if (prop in storageProxy) {
            return storageProxy[prop];
          }
          const value = target[prop];
          return typeof value === 'function' ? value.bind(target) : value;
        },
        set(target, prop, value) {
          if (prop.startsWith('okta-')) {
            window.sessionStorage.setItem(prop, value);
            return true;
          }
          target[prop] = value;
          return true;
        },
      }),
    });
  } catch (e) {
    // Fallback if override fails (e.g., in some Firefox configurations)
    console.warn('Could not override localStorage, Okta tokens may persist across sessions:', e); // eslint-disable-line no-console
  }
}

const RootWithSecurity = () => (
  <Security
    issuer={process.env.OKTA_ISSUER}
    client_id={process.env.OKTA_CLIENT_ID}
    redirect_uri={`${window.location.origin}/implicit/callback`}
    scope={['openid', 'email', 'profile', 'groups']}
  >
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Security>
);

const Root = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/dsmCallback" component={PaymentCallback} />
        <Route path="/dsmPayment" component={DummyDsmPayment} />
        <Route component={RootWithSecurity} />
      </Switch>
    </BrowserRouter>
  </Provider>
);
export default hot(module)(Root);

const renderUI = () => {
  // Render the main app react component into the app div.
  ReactDOM.render(<Root />, appDom);
};

renderUI();



// WEBPACK FOOTER //
// ./src/app/app.js